






















































import { Component, Prop } from "vue-property-decorator";
import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";

import { VFlex } from "vuetify/lib";

import { required } from "vuelidate/lib/validators";
import { IWarp10Configuration } from "sitewhere-configuration-model";

@Component({
  components: { DialogForm, FormText, VFlex },
  validations: {
    hostname: {
      required
    },
    port: {
      required
    },
    application: {
      required
    },
    tokenSecret: {
      required
    }
  }
})
export default class Warp10Fields extends DialogSection {
  @Prop() readonly readonly!: boolean;

  hostname: string | null = null;
  port: number | null = null;
  application: string | null = null;
  tokenSecret: string | null = null;

  /** Reset section content */
  reset(): void {
    this.hostname = null;
    this.port = null;
    this.application = null;
    this.tokenSecret = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  load(configuration: IWarp10Configuration): void {
    this.hostname = configuration.hostname;
    this.port = configuration.port;
    this.application = configuration.application;
    this.tokenSecret = configuration.tokenSecret;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      hostname: this.hostname,
      port: this.port,
      application: this.application,
      tokenSecret: this.tokenSecret
    };
  }
}
